'use strict';

exports.__esModule = true;
var defaultSocketOptions = exports.defaultSocketOptions = {
  secure: true,
  hostname: 'remotedev.io',
  port: 443,
  autoReconnect: true,
  autoReconnectOptions: {
    randomness: 30000
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/remote-redux-devtools/lib/constants.js
// module id = 1092
// module chunks = 31 32 33